import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import { PageHeader } from "../../components/common/States";
import TreasuryDashboard from "../../components/treasury/TreasuryDashboard";
import MovementsTab from "../../components/treasury/MovementsTab";
import ReconciliationTab from "../../components/treasury/ReconciliationTab";
import { UnpaidTab, ForecastTab } from "../../components/treasury/ReportTabs";
import { AccountsTab, SettingsTab } from "../../components/treasury/SetupTabs";

const TABS = { dashboard: ["Tableau de bord", TreasuryDashboard], movements: ["Mouvements", MovementsTab], accounts: ["Comptes", AccountsTab],
  reconciliation: ["Rapprochement", ReconciliationTab], unpaid: ["Impayés clients", UnpaidTab], forecast: ["Prévision", ForecastTab], settings: ["Catégories & charges", SettingsTab] };

export default function AdminTreasury() {
  return (
    <div>
      <PageHeader title="Trésorerie VOXA AFRIKA" description="Finances propres à l'éditeur : comptes, encaissements, décaissements, rapprochements et prévisions. Aucune donnée financière des entreprises clientes." />
      <Tabs defaultValue="dashboard">
        <TabsList className="mb-6 flex h-auto flex-wrap justify-start">{Object.entries(TABS).map(([k, [l]]) => <TabsTrigger key={k} value={k} data-testid={`treasury-tab-${k}`}>{l}</TabsTrigger>)}</TabsList>
        {Object.entries(TABS).map(([k, [, C]]) => <TabsContent key={k} value={k}><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
